import FreeSpinReel  from "./FreeSpinReel"
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import FreeSpinCell from "./FreeSpinCell";

export default class FreeSpinReelStatic extends FreeSpinReel {

    constructor(scene: any, x: number, y: number, index: number, gameLogicVariableManager: any, gameDataManager: any, orientation: any, layoutBuilder: any, freeSpinCellCreation: {cells: FreeSpinCell[]; cellPositions: any[]}) {
        super(scene, x, y, index, gameLogicVariableManager, gameDataManager, orientation, layoutBuilder, freeSpinCellCreation)
    }

    public createReelMask(orientation: any): void {
        return
        if(this.reelMask) {
            this.reelMask.destroy();
            this.container.clearMask(true);
            this.reelMask = undefined as any;
        }

        const visibleHeight = this.cellSize.height * this.numOfCellsPerReel;
        const currentOrientation = orientation;

        let xContainer = 0;
        let yContainer = 0;
        let scale = 0;

        if(currentOrientation == "portrait") {
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_X; //155
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_Y; //796
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_SCALE;
        }
        else{
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_X; //525
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_Y; //280
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_SCALE;
        }

        // crea la graphics che useremo per la mask (la aggiungiamo alla scena per poterla gestire/distruggere facilmente)
        this.reelMask = this.scene.make.graphics({ x: 0, y: 0, add: false });
        this.reelMask.fillRect(xContainer, yContainer, this.cellSize.width, visibleHeight).setScale(scale);
        

        this.container.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.reelMask));
    }
}
